
<header [ngClass]="isLanding() ? '' : 'border-bottom'">
<!--  <div class="temporary-unavailable w-100">-->
<!--    {{'This service is temporarily unavailable' | translate}}-->
<!--  </div>-->
  <nav class="navbar">
    <div class="for-mobile">
      <div class="language-dropdown">

       <div *ngIf="!isNavbarOpen">
         <button class="dropdown-btn" (click)="onBack()" [attr.aria-label]="'alt.back' | translate">
           <svg *ngIf="!isContractCreate()" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M17.2558 3.92247L16.0775 2.74414L10 8.82167L3.9225 2.74414L2.74417 3.92247L8.82167 10L2.74417 16.0775L3.9225 17.2558L10 11.1783L16.0775 17.2558L17.2558 16.0775L11.1783 10L17.2558 3.92247Z" fill="#1F1F1F"/>
           </svg>
<!--           <svg *ngIf="isContractCreate()" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--             <path d="M15.8333 10H4.16667M4.16667 10L10 15.8333M4.16667 10L10 4.16667" stroke="#1F1F1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--           </svg>-->
           <img
             *ngIf="isContractCreate()"
             src="assets/icons/icon-back.svg"
             [attr.alt]="'alt.back' | translate"
           />
         </button>
       </div>
        <div *ngIf="isNavbarOpen">
          <button [matMenuTriggerFor]="languageMenu" class="dropdown-btn language-btn-mobile">
            <img
              src="assets/icons/icon-language.svg"
              class="language-icon"
              [attr.alt]="'alt.languageIcon' | translate"
            >
            <span class="language-text-mobile">{{ currentLanguageMobile }}</span>
          </button>

          <!-- Dropdown Menu -->
          <mat-menu #languageMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of languages"
              (click)="setLanguage(item.code)"
              [class.active]="currentLanguage === item.code"
            >
              {{ item.title }}
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="navbar-logo">
      <a class="main-logo cursor-pointer d-flex shadow-none" routerLink="/landing" (click)="closeNavbar()">
        <img
          src="assets/icons/logo-sc.svg"
          [attr.alt]="'alt.logoSmartcontract' | translate"
        >
        <p>{{headerName || 'Smart Contract'}}</p>
      </a>
    </div>


    <div class="navbar-right">
      <button mat-button [matMenuTriggerFor]="languageMenu" class="language-btn-desktop">
        <span class="language-btn-label">
          <img
            src="assets/icons/icon-language.svg"
            class="language-icon"
            [attr.alt]="'alt.languageIcon' | translate"
          >
          <span class="language-text">{{ currentLanguage }}</span>
          <span class="language-arrow">&#9662;</span>
        </span>
      </button>

      <!-- Dropdown Menu -->
      <mat-menu #languageMenu="matMenu">
        <button
          mat-menu-item
          *ngFor="let item of languages"
          (click)="setLanguage(item.code)"
          [ngClass]="currentLanguage === item.code ? 'active' : ''"
        >
          {{ item.title }}
        </button>
      </mat-menu>

<!--      <div class="language-dropdown">-->
<!--        <button class="dropdown-btn btn">{{currentLanguage}} &#9662;</button>-->
<!--        <ul class="dropdown-content">-->
<!--          <li class="lang-dropdown-item linksub cursor-pointer language" ngbDropdownItem-->
<!--              *ngFor="let item of languages"-->
<!--              (click)="setLanguage(item.code);"-->
<!--              [ngClass]="currentLanguage == item.code ? 'active' : ''">-->
<!--            <a>{{item.title}}</a>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
      <button class="btn btn-primary" *ngIf="this.authService.isLoggedIn && isLanding()"
              routerLink="/">{{'cabinet' | translate }}</button>
      <button class="btn btn-primary" *ngIf="!this.authService.isLoggedIn"
              (click)="navigateToIdpLink()">{{'Log in' | translate}}</button>
      <div *ngIf="this.authService.isLoggedIn && !isLanding()">
<!--        <button class="user-name btn btn-primary" id="accountDropdown">{{authService.getUserName}} &#9662;</button>-->
                <div ngbDropdown display="dynamic" placement="bottom-end top-end" *ngIf="this.authService.isLoggedIn && !isLanding()">
                  <button class="user-name btn btn-primary" id="accountDropdown"
                          ngbDropdownToggle>{{authService.getUserName}}</button>
                  <div ngbDropdownMenu aria-labelledby="accountDropdown" class="account-dropdown p-0">
                    <ul class="account-dropdown-list">
                      <!-- Название организации — заголовок меню во всю ширину,
                           ИИН/БИН — две колонки "подпись над значением". -->
                      <li class="account-dropdown-list-li">
                        <p class="account-org" *ngIf="authService.user && authService.user.isLegal && authService.user.org">
                          {{authService.user.org[this.translate.currentLang]}}
                        </p>
                        <dl class="account-ids">
                          <div class="account-ids__item">
                            <dt>{{'foundersStep.iin' | translate}}</dt>
                            <dd>{{authService.user && authService.user.iin}}</dd>
                          </div>
                          <div class="account-ids__item" *ngIf="authService.user && authService.user.isLegal">
                            <dt>{{'BIN' | translate}}</dt>
                            <dd>{{authService.userBin}}</dd>
                          </div>
                        </dl>
                      </li>
                      <li class="account-dropdown-item account-logout">
                        <a      (click)="logout()"
                                (keydown.enter)="logout()"
                                role="button"
                                tabindex="0"
                                class="account-logout__link"
                        >
                          {{'Logout' | translate}}
                          <!-- <span class="count" *ngIf="unreadCount.personalData > 0">{{unreadCount.personalData}}</span> -->
                          <img
                            [src]="'assets/icons/icon-arrow-red.svg'"
                            [attr.alt]="'alt.logoutArrow' | translate"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>


<!--        <ul class="dropdown-content">-->
<!--          <li class="lang-dropdown-item linksub cursor-pointer language" ngbDropdownItem-->
<!--              *ngFor="let item of languages"-->
<!--              (click)="setLanguage(item.code);"-->
<!--              [ngClass]="currentLanguage == item.code ? 'active' : ''">-->
<!--            <a>{{item.title}}</a>-->
<!--          </li>-->
<!--        </ul>-->
      </div>
    </div>

    <!-- Hamburger Icon (for mobile view) -->
    <div class="hamburger openbtn" id="hamburger" (click)="toggleNavbar()"><span></span><span></span><span></span></div>
<!--    <div class="hamburger" id="hamburger" (click)="toggleNavbar()">-->
<!--&lt;!&ndash;      &#9776;&ndash;&gt;-->
<!--      <div class="openbtn"><span></span><span></span><span></span>-->
<!--    </div>-->

    <div class="navbar-collapse" id="navbarCollapse">
      <div class="navbar-collapse-box">
        <button class="btn btn-primary w-100" *ngIf="!this.authService.isLoggedIn"
                (click)="redirectToIdp()">{{ 'Login with Egov' | translate }}</button>
        <button class="btn btn-primary w-100" *ngIf="this.authService.isLoggedIn && isLanding()"
                routerLink="/" (click)="toggleNavbar()">{{'cabinet' | translate }}</button>
        <!--        <div class="divider"></div>-->
        <app-sidebar
                *ngIf="this.authService.isLoggedIn && !isLanding()"
                [isNavbar]="true"
                (toggleNavbar)="toggleNavbar()"
                (closeNavbar)="closeNavbar()"
                class="w-100"
        ></app-sidebar>
      </div>

      <app-footer></app-footer>
    </div>
  </nav>

  <!--  &lt;!&ndash; Footer bar (always visible on mobile) &ndash;&gt;-->
  <!--  <div class="footer-bar">-->
  <!--    <p>© 2024 Company Name</p>-->
  <!--  </div>-->
</header>
